import React, {useEffect} from 'react';
import './TopBar.css';
import { LOGIN_NAME, WEB_STATE } from '../../config';

const TopBar = () => {
    const username = localStorage.getItem('last_name', 'Guest') + " " + localStorage.getItem('first_name');
    useEffect(() => {
        const libscripts = document.createElement("script");
        libscripts.src = "/assets/bundles/libscripts.bundle.js";
        document.body.appendChild(libscripts);
    
        return () => {
          document.body.removeChild(libscripts);
        };
    }, []);

    function logout () {
        // localStorage.removeItem('token');
        // localStorage.removeItem('userId');
        localStorage.clear();
    };

    return (
        <nav className="top_navbar">
            
                <div className="row clearfix">
                    <div className="col-12">
                        <div className="navbar-logo">
                            <a href="#" className="bars"></a>
                            <a className="navbar-brand" href="/">
                                <span className="m-l-10 "><img className="baseLogoSize" src="/assets/images/idlink_logo_navbar.png" alt=""></img></span>
                            </a>
                        </div>
                        <div className='navbar-logo m-0 p-0 ml-5'>
                            <div className='btn btn-primary btn-round btn-simple hidden-xs col-blue border-blue disabled' style={{display: "none", cursor:"auto", opacity: "1"}} >
                                {WEB_STATE}
                            </div>
                        </div>
                        <ul className="nav navbar-nav">
                            <li className="dropdown profile">
                                <a href="" className="dropdown-toggle" data-toggle="dropdown" role="button">
                                    <img className="rounded-circle" src="/assets/images/plain_avatar.jpg" alt="User"></img>
                                </a>
                                <ul className="dropdown-menu">
                                        <div className="user-info">
                                            <h6 className="user-name m-b-0">{username}</h6>
                                        </div>
                                    <li>
                                        <a href='/login' onClick={logout} className='pointer'><i className="icon-power m-r-10"></i><span>Sign Out</span></a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>        
            
        </nav>
  );
};

export default TopBar;